<template>
  <v-container
    :class="$vuetify.breakpoint.xsOnly ? 'pt-2' : 'pt-0'"
  >
    <v-layout>
      <v-flex sm8 md9 style="display: flex">
        <img :src="require('@/assets/torilive.svg')" class="app-icon">
      </v-flex>
      <v-flex sm4 md3
        class="text-xs-right"
        :class="$vuetify.breakpoint.smAndDown ? 'pt-3' : null"
      >
        <!--
        <a id="social-facebook" class="social" target="_blank" :href="'https://www.facebook.com/sharer.php?u=' + uri + '&p=' + title">
          <img :src="require('@/assets/facebook.svg')">
        </a>
        
        <a id="social-twitter" class="social" target="_blank" :href="'https://twitter.com/intent/tweet'
          + '?text=' + title + ' - ' + desc
          + '&url=' + uri
          + '&hashtags=toriparkki,turunuusikauppatori,torilive'
        ">
          <img :src="require('@/assets/twitter.svg')">
        </a>
        <a id="social-linkedin" class="social mr-0" target="_blank" :href="'https://www.linkedin.com/shareArticle?mini=true'
          + '&url=' + uri
          + '&title=' + title
          + '&summary=' + desc
          + '&source=torilive.fi'
        ">
          <img :src="require('@/assets/linkedin.svg')">
        </a>
        -->
      </v-flex>
    </v-layout>
    <v-layout class="mt-2">
      <v-flex>
        <h2>Seuraa Turun kauppatoria aitiopaikalta.</h2>
      </v-flex>
    </v-layout>

    <v-layout class="mt-2" v-if="maintenanceOn">
      <v-alert
        :value="true"
        type="info"
        style="width: 100%"
      >
        Toriliven Internet-yhteys päivittyy. <b>Livekuva palautuu takaisin vauhdikkaampana torstaina 28.11.2019</b>
      </v-alert>
    </v-layout>

  </v-container>
</template>
<style lang="stylus" scoped>

  @import '~vuetify/src/stylus/settings/_variables.styl'

  .app-icon
    max-width 100px
    @media $display-breakpoints.sm-and-up
      max-width 200px

  .social
    margin 0 10px
    img
      max-width 40px
      @media $display-breakpoints.sm-and-up
        max-width auto

</style>
<script>

  export default {
    data: () => ({
      title: 'torilive',
      desc: encodeURIComponent('Näe Turun kauppatori livenä, välitämme aitiopaikan näkymiin.'),
      uri: encodeURI('https://torilive.fi'),
    }),

    computed: {
      maintenanceOn() {
        let today = new Date()
        return !!(
          today.getYear() === 119 &&
          today.getMonth() === 10 &&
          today.getDate() < 28
        )
      }
    },

  }

</script>